import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, AbstractControl, Validators } from '@angular/forms';
import { takeUntil, debounceTime } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { UtilityService } from '@nttp/common-service/utility-service';
import { AuthService } from '@pg-app/core/services/auth.service';
import { ToastrService } from 'ngx-toastr';
import { MatDialog } from '@angular/material/dialog';
import { CommonDialogComponent } from '@pg-app/common/common-dialog/common-dialog.component';


function compareMemorable(c: AbstractControl) {
  const v = c.value;
  return v.newMemorable === v.confirmNewMemorable
    ? null
    : {
      memorablenotmatch: true
    };
}

@Component({
  selector: 'np-change-memorable-number',
  templateUrl: './change-memorable-number.component.html',
  styleUrls: ['../change-password/change-password.component.scss']
})
export class ChangeMemorableNumberComponent implements OnInit {

  changeMemorableForm: FormGroup;
  wrongPin = false;
  destroy$ = new Subject<boolean>();

  constructor(
    private fb: FormBuilder,
    private commonService: UtilityService,
    private authService: AuthService,
    private toastr: ToastrService,
    private dialog: MatDialog
  ) { }

  ngOnInit() {
    this.changeMemorableForm = this.fb.group({
      oldMemorable: ['', Validators.required],
      newMemorable: ['', [Validators.required, Validators.minLength(6), Validators.maxLength(6)]],
      confirmNewMemorable: ''
    },
      {
        validator: [compareMemorable]
      });

    this.changeMemorableForm.get('newMemorable').valueChanges.pipe(takeUntil(this.destroy$), debounceTime(350)).subscribe(value => {
      this.checkPin(value);
    });
  }

  onDestroy() {
    this.destroy$.next(true);
    this.destroy$.complete();
  }

  checkPin(pin) {
    for (let i = 0; i < pin.length - 2; i++) {
      if (
        (pin.charCodeAt(i) + 1 === pin.charCodeAt(i + 1) && pin.charCodeAt(i) + 2 === pin.charCodeAt(i + 2)) ||
        (pin.charCodeAt(i) === pin.charCodeAt(i + 1) && pin.charCodeAt(i) === pin.charCodeAt(i + 2)) ||
        (pin.charCodeAt(i) - 1 === pin.charCodeAt(i + 1) && pin.charCodeAt(i) - 2 === pin.charCodeAt(i + 2))
      ) {
        this.wrongPin = true;
        return;
      }
    }
    this.wrongPin = false;
  }

  changeMemorable() {
    this.changeMemorableForm.markAllAsTouched();
    if (this.changeMemorableForm.valid && !this.wrongPin) {
      const params = {
        oldMemorableNumber: this.changeMemorableForm.get('oldMemorable').value,
        newMemorableNumber: this.changeMemorableForm.get('newMemorable').value,
        confirmNewMemorableNumber: this.changeMemorableForm.get('confirmNewMemorable').value,
      };
      this.commonService.updateMemorable(params).subscribe(res => {
        const dialogRef = this.dialog.open(CommonDialogComponent, {
          disableClose: true,
          data: {
            title: 'The Memorable number has changed.<br> You must re-login again.',
            dialogType: 1,
          }
        });
        dialogRef.afterClosed().subscribe(result => {
          this.authService.logout();
        });
      });
    }
  }
}
